import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-841d379e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "pt-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Areas of Practice:")
], -1))
const _hoisted_7 = { class: "caption" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Areas of care:")
], -1))
const _hoisted_9 = {
  class: "pt-1 flex",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Related Topics:")
], -1))
const _hoisted_11 = {
  class: "pt-1 flex",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption px-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Other Information:")
], -1))
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_component_ion_list, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_item, {
        button: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clearHighlight'))),
        lines: "none",
        style: _normalizeStyle({'position': _ctx.highlightContact && _ctx.highlightContact.avatar ? 'absolute' : 'relative'})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            color: "primary",
            icon: _ctx.chevronBack
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["style"]),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.highlightContact && _ctx.highlightContact.avatar)
          ? (_openBlock(), _createBlock(_component_ion_img, {
              key: 0,
              alt: "avatar",
              style: _normalizeStyle([{"margin":"auto","border-radius":"50%","height":"96px","width":"96px"}, {
          border:
            '4px solid rgb(' +
            _ctx.getColor(
              _ctx.highlightContact.category ? _ctx.highlightContact.category.name : ''
            ) +
            ')',
        }]),
              class: "my-pointer circle-me",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/home/contacts/' + _ctx.highlightContact.id))),
              src: 
          _ctx.highlightContact.avatar.formats.thumbnail
            ? _ctx.highlightContact.avatar.formats.thumbnail.url
            : _ctx.highlightContact.avatar.url
        
            }, null, 8, ["style", "src"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_ion_item, { lines: "none" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
            default: _withCtx(() => [
              _createElementVNode("h2", null, _toDisplayString(_ctx.highlightContact.name), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.highlightContact.designation), 1),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.highlightContact.organization) + " - " + _toDisplayString(_ctx.highlightContact.address) + " ", 1),
                _createElementVNode("a", {
                  href: 
              'https://www.google.com/maps/place/' + _ctx.highlightContact.address
            ,
                  target: "_blank"
                }, " (map)", 8, _hoisted_2)
              ]),
              (_ctx.highlightContact.phone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _createElementVNode("a", {
                      href: 'tel:' + _ctx.highlightContact.phone
                    }, _toDisplayString(_ctx.highlightContact.phone), 9, _hoisted_4)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/home/contacts/' + _ctx.highlightContact.id)))
                }, "More Details")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { lines: "none" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlightContact.practices, (practice) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: practice.name + 'parct'
                }, [
                  _createElementVNode("li", _hoisted_7, _toDisplayString(practice.name), 1)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.highlightContact.areas && _ctx.highlightContact.areas.length)
        ? (_openBlock(), _createBlock(_component_ion_item, {
            key: 0,
            lines: "none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlightContact.areas, (area) => {
                      return (_openBlock(), _createBlock(_component_ion_chip, {
                        color: "dark",
                        outline: "",
                        onClick: ($event: any) => (_ctx.$emit('filterSearch', area.name)),
                        key: area.id + '-area'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { color: "dark" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(area.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.highlightContact.topics && _ctx.highlightContact.topics.length)
        ? (_openBlock(), _createBlock(_component_ion_item, {
            key: 1,
            lines: "none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlightContact.topics, (topic) => {
                      return (_openBlock(), _createBlock(_component_ion_chip, {
                        color: "primary",
                        outline: "",
                        onClick: ($event: any) => (_ctx.$emit('filterSearch', topic.name)),
                        key: topic.id + '-topic'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(topic.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_12,
      _createVNode(_component_ion_item, { lines: "none" }, {
        default: _withCtx(() => [
          (_ctx.highlightContact.summary)
            ? (_openBlock(), _createElementBlock("pre", {
                key: 0,
                class: "mt-1",
                innerHTML: _ctx.$marked(_ctx.highlightContact.summary)
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}